import { getSessionCSV, getSessionXLS, getSessionReport } from '../../../../api/sessions';

export const downloadSessionCSV = (sessionId: string) => {
  return async (): Promise<void> => {
    const response = await getSessionCSV(sessionId);
    const href = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = href;
    const filename_parts = response.headers['content-disposition'].split('filename=');
    const filename = filename_parts.length === 2 ? filename_parts[1].replace(/"/g, '') : 'session.csv';
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  };
};

export const downloadSessionXLS = (sessionId: string) => {
  return async (): Promise<void> => {
    const response = await getSessionXLS(sessionId);
    const href = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = href;
    const filename_parts = response.headers['content-disposition'].split('filename=');
    const filename = filename_parts.length === 2 ? filename_parts[1].replace(/"/g, '') : 'session.xlsx';
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  };
};

export const downloadSessionReport = (sessionId: string) => {
  return async (): Promise<void> => {
    const response = await getSessionReport(sessionId);
    const href = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = href;
    const filename_parts = response.headers['content-disposition'].split('filename=');
    const filename = filename_parts.length === 2 ? filename_parts[1].replace(/"/g, '') : 'report.xlsx';
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  };
};
